(function () {
  'use strict';

  /* sticky/transparent header on homepage */
  var header = document.querySelector('.site-header');
  var transparent = document.body.classList.contains('allow-transparent-header');
  if (header && transparent) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* mobile nav toggle */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* scroll reveal */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* product thumbnails swap main image */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; }
      });
    });
  }
})();

/* keep transparent homepage header sitting just below the announcement bar */
(function(){
  function setAnnH(){
    var a = document.querySelector('.announcement');
    document.documentElement.style.setProperty('--ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  setAnnH();
  window.addEventListener('resize', setAnnH);
  window.addEventListener('load', setAnnH);
})();
